module.exports = __webpack_public_path__ + "img/inventory.1e4071e8.svg";